var _timers = {};

export default class Timing {
  constructor(name, tickInMs = 100){
    this._name = name;
    this._counterInMs = 0;
    this._tickInMs = tickInMs;
  }

  static start(name, options = {}){
    var timer = new Timing(name, options.tickInMs);
    timer.start();

    _timers[name] = timer;
    return timer;
  }

  static time(name){
    if (_timers[name]) {
      return _timers[name].time();
    }
  }

  static stop(name){
    if (_timers[name]) {
      _timers[name].stop();
    }
  }

  static clear(name){
    if(name !== undefined){
      Timing.stop(name);
      delete _timers[name];
    } else {
      for(let i in _timers){
        Timing.stop(i);
      }

      _timers = {};
    }
  }

  static pause(name){
    if (_timers[name]) {
      _timers[name].pause();
    }
  }

  static resume(name){
    if (_timers[name]) {
      _timers[name].resume();
    }
  }

  static inspect(name){
    return _timers[name];
  }

  static reset(name){
    this.clear(name);
    this.start(name);
  }

  counterInMs(){
    return this._counterInMs;
  }

  start(){
    this._timer = setInterval(function(){
      this._counterInMs = this._counterInMs + this.tickInMs();
    }.bind(this), this.tickInMs());
  }

  stop(){
    clearInterval(this._timer);
  }

  time(){
    this.stop();
    return this.counterInMs() / 1000;
  }

  pause(){
    this.stop();
  }

  resume(){
    this.start();
  }

  tickInMs(){
    return this._tickInMs;
  }

  name(){
    return this._name;
  }
}
